import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import * as Icons from "lucide-react";

export function ServiceCard({ service, testId }) {
    const { t } = useTranslation();
    const Icon = Icons[service.icon] || Icons.Stethoscope;
    return (
        <Link
            to={`/services/${service.slug}`}
            data-testid={testId || `service-card-${service.slug}`}
            className="card-soft group relative block p-6 transition-shadow duration-200"
        >
            <span
                aria-hidden
                className="absolute left-0 top-6 h-8 w-1.5 rounded-r-full"
                style={{ background: "var(--brand-teal)" }}
            />
            <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--brand-teal-soft)] text-[color:var(--brand-teal-2)]">
                <Icon className="h-5 w-5" />
            </div>
            <h3 className="mt-4 font-display text-xl font-semibold text-[color:var(--brand-navy)]">
                {service.name}
            </h3>
            <p className="mt-2 text-sm text-[color:var(--text-muted)] leading-relaxed">
                {service.short}
            </p>
            <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--brand-teal-2)] group-hover:gap-2 transition-[gap]">
                {t("cta.learnMore")}
                <ArrowRight className="h-4 w-4" />
            </div>
        </Link>
    );
}
